import api from './api';

const brandService = {
  // Get all brands with pagination and filters
  getAllBrands: async (params = {}) => {
    const searchParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== '') {
        searchParams.append(key, params[key]);
      }
    });
    
    const response = await api.get(`/brands?${searchParams.toString()}`);
    return response.data;
  },

  // Get brand by ID
  getBrandById: async (id) => {
    const response = await api.get(`/brands/id/${id}`);
    return response.data;
  },

  // Get brand by slug
  getBrandBySlug: async (slug) => {
    const response = await api.get(`/brands/${slug}`);
    return response.data;
  },

  // Get all industries
  getIndustries: async () => {
    const response = await api.get('/brands/industries');
    return response.data;
  },

  // Create new brand
  createBrand: async (brandData) => {
    const response = await api.post('/brands', brandData);
    return response.data;
  },

  // Update brand
  updateBrand: async (id, brandData) => {
    const response = await api.put(`/brands/${id}`, brandData);
    return response.data;
  },

  // Delete brand
  deleteBrand: async (id) => {
    const response = await api.delete(`/brands/${id}`);
    return response.data;
  },

  // Toggle brand active status
  toggleBrandStatus: async (id) => {
    const response = await api.patch(`/brands/${id}/toggle-active`);
    return response.data;
  }
};

export default brandService; 